import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumeric]'
})
export class NumericDirective {

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;

    // Remueve cualquier caracter que no sea número
    const numericValue = inputValue.replace(/[^0-9]/g, '');

    // Actualiza el valor solo si ha cambiado
    if (inputValue !== numericValue) {
      // Actualiza el control de formulario si estás usando Angular Forms
      this.control.control?.setValue(numericValue);
    }
  }
}


@Directive({
  selector: '[appNumeric2]'
})
export class NumericDirective2 {

  // Esto nos permite recibir un número desde el HTML.
  // Ejemplo: [appNumericMaxLength]="4"
  @Input() appNumericMaxLength: number = 0;

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const valorInicial = inputElement.value;

    // 1. Remueve cualquier caracter que no sea un número.
    let valorNumerico = valorInicial.replace(/[^0-9]/g, '');

    // Si se especificó una longitud máxima y el valor la excede, lo cortamos.
    if (this.appNumericMaxLength > 0 && valorNumerico.length > this.appNumericMaxLength) {
      valorNumerico = valorNumerico.substring(0, this.appNumericMaxLength);
    }

    // 3. Actualiza el valor en el campo solo si ha cambiado.
    if (valorInicial !== valorNumerico) {
      this.control.control?.setValue(valorNumerico);
    }
  }
}